
import { Component, Prop, Vue } from "vue-property-decorator";

// Карточка статистики партнёра на главной админки
@Component({})
export default class AdminPartnerStatCard extends Vue {
  @Prop({ required: true }) partnerUser!: {
    _id: string;
    name?: string;
    avatar?: string;
  };
  @Prop({ default: () => [] }) rows!: {
    label: string;
    value: number;
    unit?: string;
  }[];
  @Prop() badge: string | undefined;

  formatNumber(value) {
    const number = Number(value || 0);
    return number.toLocaleString("ru-RU", { maximumFractionDigits: 2 });
  }
}
